import Swal from 'sweetalert2';

/**
 * Handles the deletion of a resource.
 *
 * @param {Object} props - The props object.
 * @param {Function} props.dispatch - The Redux dispatch function.
 * @param {Function} props.deleteAction - The Redux action for deleting the resource.
 * @param {string} props.id - The ID of the resource to be deleted.
 * @param {string} props.successMessage - The success message to be displayed after the resource is deleted.
 * @param {string} props.errorMessage - The error message to be displayed if the deletion fails.
 * @returns {Promise<void>} A Promise that resolves when the deletion is complete.
 */
const deleteResourceHandler = async (props) => {
  const { dispatch, deleteAction, id, successMessage, errorMessage } = props;

  const result = await Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes',
  });

  if (result.value) {
    const resultAction = await dispatch(deleteAction(id));
    if (deleteAction.fulfilled.match(resultAction)) {
      await Swal.fire({
        icon: 'success',
        title: successMessage,
        showConfirmButton: true,
      });
      return true;
    }
    await Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: resultAction.payload || errorMessage,
      showConfirmButton: true,
    });
  }
  return false;
};

export default deleteResourceHandler;
